let storage = {
  set: function (key, val) {
    localStorage.setItem(key, JSON.stringify(val));
  },
  get: function (key) {
    return localStorage.getItem(key) === 'undefined' ? undefined : JSON.parse(localStorage.getItem(key))
  },
  remove: function (key) {
    localStorage.removeItem(key)
  },
  getUserInfo: function () {
    return this.get("userInfo")
  },
  setUserInfo: function (val) {
    this.set('userInfo', val);
  },
  getToken: function () {
    let user = this.getUserInfo();
    if (user) {
      return user.accessToken;
    }
    return null;
  }
};
export default storage;
